<template>
  <AppSection id="timesheets" type="page" :title="$t($getConst.pages.timesheet.add_timesheet)">
    <TimesheetForm></TimesheetForm>
  </AppSection>
</template>

<script>
  import TimesheetForm from "../TimesheetForm";
  import AppSection from "../../../components/common/sections/AppSection";

  export default {
    name: "index",
    components: {AppSection, TimesheetForm}
  }
</script>

<style scoped>

</style>
